import script from "./PaymentHistoryModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentHistoryModal.vue?vue&type=script&setup=true&lang=js"

import "./PaymentHistoryModal.vue?vue&type=style&index=0&id=189570d8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-189570d8"]])

export default __exports__